export default __webpack_public_path__ + "static/media/feedback.005aee25.svg";